module.exports = __webpack_public_path__ + "static/img/logo.00c9a73c.svg";